/**
 * Run all dirty checks. We can't use event aggregator because we need to wait for all checks before proceeding.
 * With the event aggregator there is no way to tell how many dirty checks will fire.
 */
export class DirtyCheckAggregator {
	private subscribers: Set<() => boolean> = new Set();

	public registerDirtyCheck(callback: () => boolean): () => boolean {
		this.subscribers.add(callback);
		return callback;
	}

	public removeDirtyCheck(callback: () => boolean): boolean {
		return this.subscribers.delete(callback);
	}

	public performDirtyCheck(): boolean {
		const anyFormHasChanges: boolean = Array.from(this.subscribers).some(
			(subscriber) => subscriber(),
		);
		return anyFormHasChanges;
	}

	/**
	 * Clear all dirty checks. Dirty checks should only exist when a specific form is open,
	 * so it doesn't hurt to clear them when changing form.
	 */
	public reset(): void {
		this.subscribers.clear();
	}
}
